import { getDesignAsset } from './designAssetService'
import { buildBindingIndex, type ResolvedNodeBinding } from './dataBindingService'
import {
  designBoundsForShapes,
  type DesignAsset,
  type DesignEmbedShape,
  type DesignEmbedSnapshot,
  type DesignShape,
} from '../types/design'
import type { TimelineElement } from '../types/timelineElement'

const buildSnapshotFromAsset = (asset: DesignAsset, elements: TimelineElement[]): DesignEmbedSnapshot => {
  const bindings = buildBindingIndex(elements)
  const bounds = designBoundsForShapes(asset.shapes)
  return {
    assetId: asset.id,
    workspaceId: asset.workspaceId,
    title: asset.title,
    mode: asset.mode,
    canvas: asset.canvas ?? null,
    bounds,
    shapes: asset.shapes.map((shape: DesignShape): DesignEmbedShape => {
      const linkedId = shape.binding?.linkedNodeId ?? null
      const resolved: ResolvedNodeBinding | null = linkedId ? bindings.get(linkedId) ?? null : null
      return {
        ...shape,
        resolved: resolved
          ? { title: resolved.title, color: resolved.color, progress: resolved.progress }
          : null,
      }
    }),
    serializedAt: Date.now(),
  }
}

export const serializeDesign = async (
  assetId: string,
  elements: TimelineElement[],
): Promise<DesignEmbedSnapshot | null> => {
  const asset = await getDesignAsset(assetId)
  if (!asset) return null
  return buildSnapshotFromAsset(asset, elements)
}

export const serializeDesignFromAsset = (
  asset: DesignAsset,
  elements: TimelineElement[],
): DesignEmbedSnapshot => buildSnapshotFromAsset(asset, elements)
